var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2579_10885)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 25C19.4036 25 25.0001 19.4035 25.0001 12.5C25.0001 5.59644 19.4036 0 12.5001 0C5.59644 0 0 5.59644 0 12.5C0 19.4035 5.59644 25 12.5001 25ZM8.66401 13.5382L5.15533 12.2287C4.79897 12.0952 4.79587 11.5921 5.15123 11.455L19.5509 5.90004C19.8562 5.78198 20.1712 6.04941 20.1046 6.37L17.5206 18.8001C17.4596 19.0935 17.1156 19.2267 16.8727 19.0501L13.3452 16.4891C13.1309 16.3335 12.8389 16.3419 12.6339 16.5088L10.6781 18.1033C10.451 18.289 10.109 18.1855 10.022 17.9058L8.66401 13.5382ZM16.6605 8.61775L9.80318 12.8411C9.54036 13.0033 9.41665 13.3207 9.50151 13.6179L10.243 16.223C10.2956 16.4076 10.5636 16.3887 10.5891 16.1979L10.7818 14.7694C10.8182 14.5004 10.9465 14.2526 11.1455 14.0674L16.8046 8.80687C16.9105 8.70871 16.7837 8.54207 16.6605 8.61775Z",
    fill: "#4AFEBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2579_10885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.6120793a06a2f8b923afaf542989c760.svg";
export { ForwardRef as ReactComponent };